module.exports = __webpack_public_path__ + "img/Kino Ravensburg.116299fd.jpg";